import { IDeal } from 'app/shared/model/deal.model';
import { IUserCashBack } from 'app/shared/model/user-cash-back.model';

export interface IUserCashBackDeal {
  id?: string;
  deal?: IDeal | null;
  userCashBack?: IUserCashBack | null;
}

export const defaultValue: Readonly<IUserCashBackDeal> = {};
